export class SalesTaxDueInfo {
	TotalTaxDue: number;
	InvoicesWithDiscrepancy: number;
	EffectedAccounts: number;
}
